<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>لیست سفارشات خدمات</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.so_id }}</td>
                                    <td class="text-xs-center">{{ props.item.quantity }}</td>
                                    <td class="text-xs-center">{{ props.item.unit_price }}</td>
                                    <td class="text-xs-center">{{ props.item.unit_price*props.item.quantity }}</td>
                                    <td class="text-xs-center">{{ toJalali(props.item.delivery_date,false) }}</td>
                                    <td class="text-xs-center"><v-chip text-color="white" :color="statuses[props.item.user_must_accept][0]">{{ statuses[props.item.user_must_accept][1] }}</v-chip></td>
                                    <td class="text-xs-center">{{ props.item.admin_description }}</td>
                                    <td class="text-xs-center">
                                        <v-btn depressed outline icon fab dark color="primary" @click="$router.push(`/pages/service_orders/edit/`+props.item.so_id)" small>
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                        <v-btn v-if="props.item.user_must_accept === 0" depressed outline icon fab dark color="pink" small>
                                            <v-icon>clear</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      statuses: [
        ['blue', 'در صف بررسی مدیران'],
        ['red', 'لغو شده'],
        ['warning', 'منتظر تایید خریدار'],
        ['yellow', 'منتظر پرداخت'],
        ['blue', 'درحال آماده سازی'],
        ['success', 'تکمیل شده'],
      ],
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شماره سفارش',
            value: 'so_id',
            align: 'center'
          },
          {
            text: 'تعداد',
            value: 'quantity',
            align: 'center'
          },
          {
            text: 'قیمت واحد',
            value: 'unit_price',
            align: 'center'
          },
          {
            text: 'مجموع (ریال)',
            value: 'unit_price',
            align: 'center'
          },
          {
            text: 'تاریخ تحویل',
            value: 'delivery_date',
            align: 'center'
          },
          {
            text: 'وضعیت',
            value: 'user_must_accept',
            align: 'center'
          },
          {
            text: '',
            value: 'admin_description',
            align: 'center'
          },

          {
            text: 'مدیریت',
            value: '',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  created: function () {
    this.axios.get('/reseller/service_orders/')
      .then(response => {
        this.complex.items = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/service_orders/modify.vue